export const GoogleMapApiConfig = 'AIzaSyD-1wbP9hcKh3mMjoh4YzTDKplchfGVV8k';